import { ReactComponent as FaceBookIcon } from './icons/facebook_circle_logo.svg'
import { ReactComponent as WhatsappIcon } from './icons/whatsapp_circle_logo.svg'
import { ReactComponent as TelegramIcon } from './icons/telegram_circle_logo.svg'
import { ReactComponent as ViberIcon } from './icons/viber_circle_logo.svg'
import { ReactComponent as GmailIcon } from './icons/gmail_circle_logo.svg'

export const formatTextForURL = (text) => {
  return encodeURIComponent(text.replace(/\n/g, '\n'));
};

export const extractLinksFromText = (text) => {
  const urlRegex = /(https?:\/\/[^\s]+)/g;
  const links = text.match(urlRegex) || [];

  // Move the link with 'referral' query parameter to the first position
  const referralLinkIndex = links.findIndex(link => {
    try {
      const url = new URL(link);
      return url.searchParams.has('referral');
    } catch (e) {
      return false;
    }
  });

  if (referralLinkIndex > 0) {
    const [referralLink] = links.splice(referralLinkIndex, 1);
    links.unshift(referralLink);
  }

  return links;
};

export const getLinks = (id, defaultLink) => {
  const link = !defaultLink ? encodeURIComponent(`${window.location.origin}/vacancy/?id=${id}`) : formatTextForURL(defaultLink)
  let refLinks = []
  let viberLink = ''
  let facebookRefLink = ''

  if (defaultLink) {
    refLinks = extractLinksFromText(defaultLink)
    let referralCode = '';
    if (refLinks[0] || refLinks[1]) {
      const url = new URL(refLinks[0]);
      referralCode = url.searchParams.get('referral');
      facebookRefLink = `${refLinks[0]}`
    }

    if (referralCode && refLinks[1] && refLinks[0]) {
      viberLink = `
Join the Telegram Channel
${refLinks[1]}

Register on NextShip
${refLinks[0]}
    
Enter the PROMO CODE: ${referralCode}
`
    }
  }

  return [
    { Icon: FaceBookIcon, link: `https://www.facebook.com/sharer/sharer.php?display=popup&sdk=joey&u=${defaultLink ? facebookRefLink : link}` },
    { Icon: WhatsappIcon, link: `https://api.whatsapp.com/send/?text=${link}&type=${link}&app_absent=0` },
    { Icon: TelegramIcon, link: `https://t.me/share/url?url=${link}` },
    { Icon: ViberIcon, link: `viber://forward?text=${defaultLink && viberLink ? formatTextForURL(viberLink) : facebookRefLink}` },
    { Icon: GmailIcon, link: `mailto:?subject=Тема&body=${link}` },
  ]
}
